import styled from 'styled-components';

import {
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

const MOBILE = '@media (max-width: 768px)';

export const Bar = styled.div`
  position: relative;
  z-index: 1;
  border-top: 0.1rem solid ${LandingHero.band.border};
  padding: 3.6rem 7.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3.2rem;
  flex-wrap: wrap;

  ${MOBILE} {
    padding: 2.4rem 2.4rem;
  }
`;

export const LogoGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const LogoMark = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 1rem;
  background: ${LandingHero.logoGradient};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${HERO_FONT_DISPLAY};
  font-size: 1.6rem;
  font-weight: 800;
  color: ${LandingHero.logoText};
  box-shadow: 0 0.6rem 1.8rem -0.6rem ${LandingHero.logoShadow};
`;

export const Wordmark = styled.div`
  font-family: ${HERO_FONT_DISPLAY};
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.02rem;
  color: ${LandingHero.textPrimary};
`;

export const LinkRow = styled.div`
  display: flex;
  align-items: center;
  gap: 2.8rem;
`;

export const FooterLink = styled.button`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${LandingHero.navLink};
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  transition: color 0.25s ease;

  &:hover {
    color: ${LandingHero.navLinkHover};
  }
`;

export const ContactLink = styled.a`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${LandingHero.navLink};
  transition: color 0.25s ease;

  &:hover {
    color: ${LandingHero.navLinkHover};
  }
`;

export const Copyright = styled.div`
  font-size: 1.3rem;
  color: ${LandingHero.textFaint};
`;
